import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitNonAthleteEntryCredentialsData from './GetOrgUnitNonAthleteEntryCredentialsData';
import getOrgUnitNonAthleteEntryData from './GetOrgUnitNonAthleteEntryData';
import postOrgUnitNonAthleteEntryData from './PostOrgUnitNonAthleteEntryData';
import putOrgUnitNonAthleteEntryData from './PutOrgUnitNonAthleteEntryData';
import deleteOrgUnitNonAthleteEntryData from './DeleteOrgUnitNonAthleteEntryData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OmeMeetOrgUnitNonAthleteEntryData = {
  INITIAL_STATE, getOrgUnitNonAthleteEntryCredentialsData, getOrgUnitNonAthleteEntryData,
  postOrgUnitNonAthleteEntryData, putOrgUnitNonAthleteEntryData, deleteOrgUnitNonAthleteEntryData
};

export default OmeMeetOrgUnitNonAthleteEntryData;